import { call, put, select } from 'redux-saga/effects'

import Lifecycle from 'common/modules/lifecycle'
import Internal from 'common/modules/internal'
import Loader from 'common/modules/loader'
import Zoid from 'common/modules/zoid'
import PaymentV2 from 'common/modules/paymentv2'
import logger from 'common/logger'

import { creators } from 'common/modules/arbiter/actions'
import selectors from 'common/modules/arbiter/selectors'
import PopupsProcessor from 'common/modules/popupsProcessor'

import { handleArticle } from './loaderActions'

export function* watchLoaderSuccess({ payload: { scope = 'guest' } }) {
    const {
        events,
        initializeDecorators = () => { },
        updateDecorators = () => { },
        adBlockDetector,
    } = yield select(Zoid.selectors.getXprops)

    const loader = yield select(Loader.selectors.loader)
    const scopedLoader = loader[scope]

    if (scope === 'user') {
        const publisherId = yield select(Loader.selectors.publisherId)

        yield put(
            yield call(PaymentV2.creators.getPayments, {
                payload: {
                    publisherId,
                },
            }),
        )
    }

    const haveAllFrameInitialized = yield select(selectors.haveAllFrameInitialized)

    if (haveAllFrameInitialized) {
        yield put(Internal.creators.sendMessage({
            payload: {
                target: '*',
                ...Loader.creators.loaderIsNotFetching(),
            },
        }))

        yield put(Internal.creators.sendMessage({
            payload: {
                target: '*',
                ...Loader.creators.getLoaderSuccess({
                    scope,
                    data: scopedLoader,
                }),
            },
        }))

        const adBlocked = yield adBlockDetector()
        const decoratorPayload = yield select(selectors.decoratorPayload, adBlocked)

        const picoInit = yield select(selectors.hasPicoInitialed)
        const userWindowObject = yield select(Loader.selectors.userWindowObject)

        if (!picoInit) {
            yield initializeDecorators(decoratorPayload)

            events.update(userWindowObject, 'PICO/LOADED')

            yield put(creators.picoInit({ origin: 'loader' }))
        } else {
            yield updateDecorators(decoratorPayload)

            events.update(userWindowObject, 'PICO/UPDATED')
        }
    }

    yield call(handleArticle)

    const executePopupsProcessor = yield select(selectors.executePopupsProcessor)
    const initComplete = yield select(selectors.initComplete)

    const canShowPopup = yield select(selectors.canShowPopup)

    if (executePopupsProcessor && initComplete && canShowPopup) {
        const popups = scopedLoader?.popups || []

        const { runInProgress } = yield select(PopupsProcessor.selectors.popupsProcessor) || {}

        if (!runInProgress && popups.length) {
            yield put(
                yield call(
                    PopupsProcessor.creators.set,
                    {
                        payload: {
                            popups,
                        },
                    },
                ),
            )

            yield put(
                yield call(
                    PopupsProcessor.creators.run,
                ),
            )
        }
    }
    // currently, no post loader actions are being executed, but this is here in case
    // any actions should be executed after the loader is fetched successfully
    // const executePostLoaderActions = yield select(selectors.executePostLoaderActions)
    // if (executePostLoaderActions) {}
}

export function* watchLoaderError({ error }) {
    yield put(Internal.creators.sendMessage({
        payload: {
            target: '*',
            ...Loader.creators.loaderIsNotFetching(),
        },
    }))

    if (error?.message === 'Unauthorized User') {
        const loader = yield select(Loader.selectors.loader)
        const userEmail = yield select(Loader.selectors.userEmail)
        const userAuthed = yield select(Loader.selectors.userAuth)
        const userId = yield select(Loader.selectors.userId)
        yield put(Lifecycle.creators.userLogout({ payload: loader }))
        logger.info('Gadget logout due to unauthorized user', {
            userInfo: {
                userEmail,
                userAuthed,
                userId,
            },
            unauthedReason: error?.reason,
        })
        yield put({
            type: 'AUTH/LOGOUT',
        })
    }
}

export function* watchLoaderRequest() {
    yield put(Internal.creators.sendMessage({
        payload: {
            target: '*',
            ...Loader.creators.loaderIsFetching(),
        },
    }))
}
